<!-- event-type.component.html -->
<main>
    <div>
        <div class="eventType-head">
            <div class="header-text eventType-text">
                Event Managers
            </div>
            <div>
                <app-button label="Add New" [minWidth]="'8rem'" (clicked)="openAddDialog()">
                </app-button>
            </div>
        </div>

        <div class="table-card">
            <app-table [columns]="columns" [data]="data" [actionTemplate]="actionButtonsTemplate" [loading]="loading">
            </app-table>
        </div>
    </div>
</main>

<ng-template #actionButtons let-row>
    <div style="display: flex; gap: 0.8rem; justify-content: center;">
        <img class="action-button" (click)="onEdit(row)" src="assets/images/Buttons/edit-button.svg" alt="Edit" />
        <img class="action-button" (click)="onDelete(row)" src="assets/images/Buttons/delete-button.svg" alt="Delete" />
    </div>
</ng-template>

<ng-template #addEventTypeContent>
    <add-event-manager [initialData]="editingEventType" (formSubmitted)="onEventTypeFormSubmit($event)">
    </add-event-manager>

</ng-template>